// import React, { useState, useEffect } from "react";
// import axios from "axios";
// import { useLocation } from "react-router-dom";
// import "./VerifyCertificate.css";

// const VerifyCertificate = () => {
//   const [certificateId, setCertificateId] = useState("");
//   const [result, setResult] = useState("");
//   const [loading, setLoading] = useState(false);
//   const [certificate, setCertificate] = useState(null);
//   const location = useLocation();

//   // ✅ Auto-run verification if certificateId is passed in query (from QR)
//   useEffect(() => {
//     const params = new URLSearchParams(location.search);
//     const idFromQR = params.get("certificateId");
//     if (idFromQR) {
//       setCertificateId(idFromQR);
//       verifyCertificate(idFromQR);
//     }
//   }, [location]);

//   const verifyCertificate = async (id) => {
//     if (!id.trim()) return;
//     setLoading(true);
//     setResult("");
//     setCertificate(null);

//     try {
//       const res = await axios.get(
//         `http://localhost:5000/api/certificates/verify/${id.trim()}`
//       );

//       if (res.data.success && res.data.certificate) {
//         setCertificate(res.data.certificate);
//         setResult("✅ Certificate is Valid");
//       } else {
//         setResult("❌ Certificate not found or invalid!");
//       }
//     } catch (err) {
//       setResult("⚠️ Unable to reach verification server. Please try again later.");
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleSubmit = (e) => {
//     e.preventDefault();
//     verifyCertificate(certificateId);
//   };

//   return (
//     <div className="verify-container">
//       <div className="verify-card">
//         <h1 className="verify-title">Certificate Verification</h1>

//         <form onSubmit={handleSubmit} className="verify-form">
//           <input
//             type="text"
//             placeholder="Enter Certificate ID"
//             value={certificateId}
//             onChange={(e) => setCertificateId(e.target.value)}
//             className="verify-input"
//             required
//           />
//           <button
//             type="submit"
//             disabled={loading}
//             className="verify-button"
//           >
//             {loading ? "Verifying..." : "Verify"}
//           </button>
//         </form>

//         {result && (
//           <p
//             className={`verify-result ${
//               result.includes("✅")
//                 ? "valid"
//                 : result.includes("⚠️")
//                 ? "warning"
//                 : "invalid"
//             }`}
//           >
//             {result}
//           </p>
//         )}

//         {certificate && (
//           <div className="certificate-details">
//             <h2>Certificate Details</h2>
//             <p><strong>Name:</strong> {certificate.employeeName}</p>
//             <p><strong>Course:</strong> {certificate.course}</p>
//             <p><strong>Start Date:</strong> {certificate.startDate}</p>
//             <p><strong>End Date:</strong> {certificate.endDate}</p>
//             <p><strong>CIN ID:</strong> {certificate.cinId}</p>
//           </div>
//         )}
//       </div>
//     </div>
//   );
// };

// export default VerifyCertificate;




// import React, { useState, useEffect } from "react";
// import axios from "axios";
// import { useLocation } from "react-router-dom";
// import "./VerifyCertificate.css";

// const VerifyCertificate = () => {
//   const [certificateId, setCertificateId] = useState("");
//   const [result, setResult] = useState("");
//   const [loading, setLoading] = useState(false);
//   const [certificate, setCertificate] = useState(null);
//   const location = useLocation();

//   // ✅ Backend Base URL (change only this if you redeploy)
//   const BASE_URL = "https://devops-team-3.onrender.com";

//   // ✅ Auto-run verification if certificateId is passed in query (from QR)
//   useEffect(() => {
//     const params = new URLSearchParams(location.search);
//     const idFromQR = params.get("certificateId");
//     if (idFromQR) {
//       setCertificateId(idFromQR);
//       verifyCertificate(idFromQR);
//     }
//   }, [location]);

//   const verifyCertificate = async (id) => {
//     if (!id.trim()) return;
//     setLoading(true);
//     setResult("");
//     setCertificate(null);

//     try {
//       const res = await axios.get(`${BASE_URL}/api/certificates/verify/${id.trim()}`);

//       if (res.data.success && res.data.certificate) {
//         setCertificate(res.data.certificate);
//         setResult("✅ Certificate is Valid");
//       } else {
//         setResult("❌ Certificate not found or invalid!");
//       }
//     } catch (err) {
//       console.error("Verification error:", err);
//       setResult("⚠️ Unable to reach verification server. Please try again later.");
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleSubmit = (e) => {
//     e.preventDefault();
//     verifyCertificate(certificateId);
//   };

//   return (
//     <div className="verify-container">
//       <div className="verify-card">
//         <h1 className="verify-title">Certificate Verification</h1>

//         <form onSubmit={handleSubmit} className="verify-form">
//           <input
//             type="text"
//             placeholder="Enter Certificate ID"
//             value={certificateId}
//             onChange={(e) => setCertificateId(e.target.value)}
//             className="verify-input"
//             required
//           />
//           <button type="submit" disabled={loading} className="verify-button">
//             {loading ? "Verifying..." : "Verify"}
//           </button>
//         </form>

//         {result && (
//           <p
//             className={`verify-result ${
//               result.includes("✅")
//                 ? "valid"
//                 : result.includes("⚠️")
//                 ? "warning"
//                 : "invalid"
//             }`}
//           >
//             {result}
//           </p>
//         )}

//         {certificate && (
//           <div className="certificate-details">
//             <h2>Certificate Details</h2>
//             <p><strong>Name:</strong> {certificate.employeeName}</p>
//             <p><strong>Course:</strong> {certificate.course}</p>
//             <p><strong>Start Date:</strong> {certificate.startDate}</p>
//             <p><strong>End Date:</strong> {certificate.endDate}</p>
//             <p><strong>CIN ID:</strong> {certificate.cinId}</p>
//           </div>
//         )}
//       </div>
//     </div>
//   );
// };

// export default VerifyCertificate;
import React, { useState, useEffect } from "react";
import axios from "axios";
import { useLocation } from "react-router-dom";
import "./VerifyCertificate.css";

const VerifyCertificate = () => {
  const [certificateId, setCertificateId] = useState("");
  const [result, setResult] = useState("");
  const [loading, setLoading] = useState(false);
  const [certificate, setCertificate] = useState(null);
  const location = useLocation();

  // ✅ Updated Backend Base URL
  const BASE_URL = "https://vs-certificate.onrender.com";

  // ✅ Auto-run verification if certificateId is passed in query (from QR)
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const idFromQR = params.get("certificateId");
    if (idFromQR) {
      setCertificateId(idFromQR);
      verifyCertificate(idFromQR);
    }
  }, [location]);

  const verifyCertificate = async (id) => {
    if (!id.trim()) return;
    setLoading(true);
    setResult("");
    setCertificate(null);

    try {
      const res = await axios.get(`${BASE_URL}/api/certificates/verify/${id.trim()}`);
      console.log(res, "res")
      console.log(res?.data, "res1")

      if (res.status === 200) {
        setCertificate(res.data.certificate);
        setResult("✅ Certificate is Valid");
      }
    } catch (err) {
      console.error("Verification error:", err);
      setResult("❌ Certificate not found or invalid!");
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    verifyCertificate(certificateId);
  };

  return (
    <div className="verify-container">
      <div className="verify-card">
        <h1 className="verify-title">Certificate Verification</h1>

        <form onSubmit={handleSubmit} className="verify-form">
          <input
            type="text"
            placeholder="Enter Certificate ID"
            value={certificateId}
            onChange={(e) => setCertificateId(e.target.value)}
            className="verify-input"
            required
          />
          <button type="submit" disabled={loading} className="verify-button">
            {loading ? "Verifying..." : "Verify"}
          </button>
        </form>

        {result && (
          <p
            className={`verify-result ${result.includes("✅")
                ? "valid"
                : result.includes("⚠️")
                  ? "warning"
                  : "invalid"
              }`}
          >
            {result}
          </p>
        )}

        {certificate && (
          <div className="certificate-details">
            <h2>Certificate Details</h2>
            <p><strong>Name:</strong> {certificate.employeeName}</p>
            <p><strong>Course:</strong> {certificate.course}</p>
            <p><strong>Start Date:</strong> {certificate.startDate}</p>
            <p><strong>End Date:</strong> {certificate.endDate}</p>
            {/* <p><strong>CIN ID:</strong> {certificate.cinId}</p> */}
          </div>
        )}
      </div>
    </div>
  );
};

export default VerifyCertificate;
